import gql from 'graphql-tag';

export const createFinancingBrazilGrowerLead = gql`
  mutation createFinancingBrazilGrowerLead($data: FinancingBrazilGrowerLeadCreateInput!) {
    createFinancingBrazilGrowerLead(data: $data) {
      id
    }
  }
`;

export const financingStates = gql`
  query {
    financingStates {
      id
      name
      code
    }
  }
`;

export const financingMunicipalitiesByState = gql`
  query FinancingMunicipalitiesWhereInput($stateId: Int) {
    financingMunicipalities(where: { stateId: $stateId }) {
      id
      name
    }
  }
`;
